import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import { nanoid } from 'nanoid'

import { ILocales } from 'shared/constants/date-locale'
import { getLocaleDays } from 'shared/lib/getLocaleDates'
import { Paper } from 'shared/ui/paper'

import { RenderDay } from './days'
import { DayProps, DaysOfWeek } from './days/model'
import s from './styles.module.scss'

export interface DateMonth extends DayProps {
  type?: 'active' | 'border' | 'disabled' | 'range' | 'selected' | 'flexible' //| 'current'
  color?: string
  fullDate?: string
}

export interface Props {
  monthStart: DaysOfWeek
  month: number
  year: number
  date?: DateMonth[]
  onClick?: (day: string) => void
}

const LocalMonth = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
] as const

export const Month: FC<Props> = ({
  monthStart,
  month,
  year,
  date,
  onClick,
}) => {
  const { t, i18n } = useTranslation()

  const defaultLanguage = i18n.language

  const monthOfWeek = getLocaleDays(defaultLanguage as ILocales)

  const onClickHandler = (day: string) => {
    onClick?.(`${year}/${month}/${day}`)
  }

  return (
    <Paper padding={[0]}>
      <div
        className={s.container}
        id={'datepicker'}
      >
        <div className={s.header}>
          <p className={clsx(s.month, 'bold-16')}>{t(LocalMonth[month - 1])}</p>

          <p className={clsx(s.year, 'bold-16')}>{year}</p>
        </div>
        <div className={s.weekName}>
          {monthOfWeek?.map((week) => (
            <div
              key={nanoid()}
              className={clsx(s.week, 'bold-14')}
            >
              {week}
            </div>
          ))}
        </div>

        <div className={s.week}>
          {[...Array(monthStart)]?.map(() => (
            <div
              className={s.day}
              key={nanoid()}
            />
          ))}

          {date?.map((day) => {
            return (
              <div
                className={s.day}
                key={nanoid()}
                data-calendar-date={day.fullDate}
              >
                <RenderDay
                  day={day}
                  onClick={onClickHandler}
                />
              </div>
            )
          })}
        </div>
      </div>
    </Paper>
  )
}
